import { push } from 'react-router-redux';
import {
  ACTION_PREFIX,
  MYTRACK_SERVICE_SIMACT_UNAVAILABLE,
  UI_COLLECTION_MFA,
} from '../../helpers/constants';
import { sendDirect } from '../request/sendDirect';
import MfaInitiateRequest, { isMfaError } from '../../model/requests/MfaInitiateRequest';
import { showMfaForm } from '../dialog/misc';
import ApiError from '../../model/errors/ApiError';
import MfaInfoRequest from '../../model/requests/MfaInfoRequest';
import { showDialog } from '../page/dialog';
import { trackMyState } from '../tracking/event';
import * as registryActions from '../request/registry';
import { send } from '../request/send';

const ERR_CODE_CRITICAL_EVENT_MULTI_FACTOR_REQUIRED = '9013';

export const STORE_MFA_PROCESS = `${ACTION_PREFIX}/STORE_MFA_PROCESS`;
export const REMOVE_MFA = `${ACTION_PREFIX}/REMOVE_MFA`;
export const COMPLETE_MFA = `${ACTION_PREFIX}/COMPLETE_MFA`;

export const storeMfaProcess = ({
  mfaToken,
  mfaProcess,
}) => ({
  type: STORE_MFA_PROCESS,
  payload: {
    mfaToken,
    mfaProcess,
  },
});

export const removeMfa = ({
  mfaToken,
}) => ({
  type: REMOVE_MFA,
  payload: {
    mfaToken,
  },
});

export const completeMfa = ({
  mfaToken,
}) => ({
  type: COMPLETE_MFA,
  payload: {
    mfaToken,
  },
});

export const showMfaLockedDialog = () => async (dispatch, getState) => {
  await dispatch(registryActions.fetchUiElements([UI_COLLECTION_MFA]));
  const { site, ui } = getState();
  dispatch(showDialog({
    headline: ui.mfaErrTitle,
    copy: ui.mfaErrLocked,
    actions: [
      {
        label: ui.guiWordAllright,
        withoutArrow: true,
      }],
  }));
  dispatch(push(site.sitemap.MyDashboardRoute.url));
  dispatch(trackMyState(MYTRACK_SERVICE_SIMACT_UNAVAILABLE));
};
export const showNoMfaMethodIsAvailableDialog = () => async (dispatch, getState) => {
  await dispatch(registryActions.fetchUiElements([UI_COLLECTION_MFA]));
  const { site, ui } = getState();
  dispatch(showDialog({
    headline: ui.mfaErrTitle,
    copy: ui.mfaErrNoTan,
    actions: [
      {
        label: ui.guiWordAllright,
        withoutArrow: true,
      }],
  }));
  dispatch(push(site.sitemap.MyDashboardRoute.url));
  dispatch(trackMyState(MYTRACK_SERVICE_SIMACT_UNAVAILABLE));
};

export const mfaNotPossible = () => async (dispatch, getState) => {
  const { user } = getState();
  const { msisdn } = user.credentials;
  const response = await dispatch(send(new MfaInfoRequest(msisdn)));
  const result = response.body.data;
  const { multifactorCurrentlyLocked, mfaMethods } = result;
  if (multifactorCurrentlyLocked) {
    await dispatch(showMfaLockedDialog());
    return true;
  }
  if (mfaMethods.length === 0) {
    dispatch(showNoMfaMethodIsAvailableDialog());
    return true;
  }
  return false;
};

export const initiateMfaDirect = ({
  mfaToken,
  mfaMethod,
}) => async (dispatch, getState) => {
  const { user } = getState();
  const { msisdn } = user.credentials;

  try {
    const response = await dispatch(
      sendDirect(new MfaInitiateRequest(msisdn, mfaToken, mfaMethod)),
    );
    const result = response.body.data;

    await dispatch(storeMfaProcess({
      mfaToken,
      mfaProcess: result.activeMultifactorProcess,
    }));

    dispatch(showMfaForm({
      mfaToken,
      mfaProcess: result.activeMultifactorProcess,
    }));
  } catch (err) {
    if (isMfaError(err)) {
      dispatch(showMfaForm({
        mfaToken,
        initiateError: err,
      }));
    }
  }
};

export const handleCriticalEvent = (err) => async (dispatch) => {
  if (!(err instanceof ApiError)) {
    return true;
  }
  if (err.code === ERR_CODE_CRITICAL_EVENT_MULTI_FACTOR_REQUIRED) {
    const { 'x-multifactor-token': mfaToken, availableMethods } = err._details.errorHints;
    dispatch(initiateMfaDirect({ mfaMethod: availableMethods[0], mfaToken }));
    return false;
  }
  return true;
};
